import { useEffect, useState } from "react";

const STORAGE_KEY = "trocaenvio.backoffice.cookieNoticeAccepted.v1";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      // localStorage indisponível (navegação privada): mostra mesmo assim.
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  function accept() {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      // ignore
    }
    setVisible(false);
  }

  return (
    <div role="dialog" aria-label="Aviso de privacidade" style={styles.wrap}>
      <p style={styles.text}>
        Usamos cookies/armazenamento local apenas para manter sua sessão e preferências
        operacionais do painel. Sem rastreio publicitário. Saiba mais na nossa{" "}
        <a href="/legal/privacy.html" target="_blank" rel="noreferrer" style={styles.link}>
          Política de Privacidade
        </a>{" "}
        e nos{" "}
        <a href="/legal/terms.html" target="_blank" rel="noreferrer" style={styles.link}>
          Termos de Uso
        </a>
        .
      </p>
      <button type="button" onClick={accept} style={styles.btn}>
        Entendi
      </button>
    </div>
  );
}

const styles = {
  wrap: {
    position: "fixed",
    left: 16,
    right: 16,
    bottom: 16,
    background: "#FFFFFF",
    borderRadius: 12,
    padding: "12px 16px",
    boxShadow: "0 6px 24px rgba(20, 38, 70, 0.18)",
    border: "1px solid #DBE8F1",
    display: "flex",
    alignItems: "center",
    gap: 12,
    zIndex: 9999,
    flexWrap: "wrap",
  },
  text: { margin: 0, color: "#163557", fontSize: 13, lineHeight: 1.4, flex: 1, minWidth: 240 },
  link: { color: "#00B6A5", fontWeight: 600 },
  btn: {
    background: "#00B6A5",
    color: "#fff",
    border: 0,
    padding: "8px 16px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
  },
};
